/**
 * Fellido · Promo-Leiste mit Countdown
 *
 * Betriebsarten:
 *  - "date"    laeuft auf einen festen Termin zu. Ist er vorbei, verschwindet
 *              die Leiste, statt bei 00:00:00 stehenzubleiben.
 *  - "daily"   zaehlt auf den taeglichen Versandschluss. Nach der Uhrzeit
 *              zaehlt sie auf den naechsten Werktag.
 *  - "rolling" wiederkehrendes Fenster, z. B. immer 48 Stunden. Zwei Bezuege:
 *              "grid"    = fester Rhythmus ab einem Stichtag. Fuer alle
 *                          Besucher identisch, laeuft sichtbar ab und startet
 *                          dann neu. Das ist die ehrliche Variante.
 *              "visitor" = startet beim ersten Seitenbesuch und wird im
 *                          Browser gemerkt. Zeigt jedem Neubesucher die vollen
 *                          Stunden. Springt beim Neuladen NICHT zurueck, aber
 *                          zwei Besucher sehen unterschiedliche Zeiten.
 */

// Stichtag fuer den festen Rhythmus: Montag, 05.01.2026, 00:00 Ortszeit.
const F_PROMO_ANKER = new Date(2026, 0, 5, 0, 0, 0, 0).getTime();

class FPromo extends HTMLElement {
  connectedCallback() {
    this.modus = this.dataset.mode || 'daily';

    // Betriebsart "datum" braucht keine Uhr — nur ein Textfeld.
    if (this.modus === 'datum') {
      this.datumsfeld = this.querySelector('[data-f-p-date]');
      if (!this.datumsfeld) return;
      this.zeigeDatum();
      // Einmal pro Minute nachziehen, damit es um Mitternacht mitwandert.
      this.takt = setInterval(() => this.zeigeDatum(), 60000);
      return;
    }

    this.felder = {
      t: this.querySelector('[data-f-p-d]'),
      h: this.querySelector('[data-f-p-h]'),
      m: this.querySelector('[data-f-p-m]'),
      s: this.querySelector('[data-f-p-s]'),
    };
    this.tageWrap = this.querySelector('[data-f-p-dwrap]');
    if (!this.felder.h) return;

    this.tick();
    this.takt = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.takt);
  }

  /** Mitwanderndes Datum: heute + Versatz, ohne Uhrzeit. */
  zeigeDatum() {
    const versatz = parseInt(this.dataset.offset, 10);
    const d = new Date();
    d.setDate(d.getDate() + (Number.isFinite(versatz) ? versatz : 2));
    const sprache = this.dataset.locale || document.documentElement.lang || 'de-DE';
    let text;
    try {
      text = d.toLocaleDateString(sprache, { weekday: 'long', day: 'numeric', month: 'long' });
    } catch (e) {
      text = d.toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long' });
    }
    this.datumsfeld.textContent = text;
  }

  /** Fensterlaenge in Millisekunden, mindestens eine Stunde. */
  fenster() {
    const std = parseInt(this.dataset.window, 10);
    return (Number.isFinite(std) && std > 0 ? std : 48) * 3600000;
  }

  /** Wiederkehrendes Fenster auf festem Raster — fuer alle gleich. */
  rasterZiel() {
    const f = this.fenster();
    const seit = Date.now() - F_PROMO_ANKER;
    return new Date(F_PROMO_ANKER + (Math.floor(seit / f) + 1) * f);
  }

  /** Wiederkehrendes Fenster pro Besucher, im Browser gemerkt. */
  besucherZiel() {
    const f = this.fenster();
    const schluessel = 'f-promo-frist-' + (this.dataset.key || f);
    try {
      const gemerkt = parseInt(localStorage.getItem(schluessel), 10);
      if (Number.isFinite(gemerkt) && gemerkt > Date.now()) return new Date(gemerkt);
      const neu = Date.now() + f;
      localStorage.setItem(schluessel, String(neu));
      return new Date(neu);
    } catch (e) {
      // Privater Modus o. ae.: lieber das feste Raster als gar nichts.
      return this.rasterZiel();
    }
  }

  ziel() {
    if (this.modus === 'date') {
      const d = new Date(this.dataset.until || '');
      return isNaN(d.getTime()) ? null : d;
    }
    if (this.modus === 'rolling') {
      return this.dataset.anchor === 'visitor' ? this.besucherZiel() : this.rasterZiel();
    }
    // Taeglicher Versandschluss
    const [std, min] = (this.dataset.cutoff || '15:00').split(':').map(Number);
    const jetzt = new Date();
    const z = new Date(jetzt);
    z.setHours(std || 15, min || 0, 0, 0);
    if (z <= jetzt) z.setDate(z.getDate() + 1);
    if (this.dataset.workdays === 'true') {
      // Samstag und Sonntag ueberspringen
      while (z.getDay() === 0 || z.getDay() === 6) z.setDate(z.getDate() + 1);
    }
    return z;
  }

  tick() {
    const z = this.ziel();
    if (!z) return;
    let rest = z.getTime() - Date.now();

    if (rest <= 0) {
      if (this.modus === 'date') {
        // Abgelaufen: lieber weg als eine tote Null anzeigen.
        clearInterval(this.takt);
        this.hidden = true;
        return;
      }
      // Rolling und daily laufen weiter — naechstes Fenster holen.
      rest = this.ziel().getTime() - Date.now();
      if (rest <= 0) return;
    }

    const sek = Math.floor(rest / 1000);
    const tage = Math.floor(sek / 86400);
    const std = Math.floor((sek % 86400) / 3600);
    const min = Math.floor((sek % 3600) / 60);
    const s = sek % 60;

    const zz = (n) => String(n).padStart(2, '0');
    // Bei "Stunden am Stueck" laufen die Tage in die Stundenanzeige mit ein.
    const tageAus = this.dataset.hoursOnly === 'true';
    if (this.tageWrap) this.tageWrap.hidden = tageAus || tage === 0;
    if (this.felder.t) this.felder.t.textContent = zz(tage);
    this.felder.h.textContent = zz(tageAus ? tage * 24 + std : std);
    this.felder.m.textContent = zz(min);
    if (this.felder.s) this.felder.s.textContent = zz(s);
  }
}

if (!customElements.get('f-promo')) customElements.define('f-promo', FPromo);
